
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4a54bc5a\",\"scoped\":true,\"hasInlineConfig\":false}!stylus-loader?{\"import\":[\"C:\\\\Users\\\\NeferUser\\\\Desktop\\\\www\\\\site_config\\\\aomenbaijiale\\\\styl\\\\variables.styl\"],\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./priceList.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./priceList.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4a54bc5a\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./priceList.vue"),
  /* scopeId */
  "data-v-4a54bc5a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/pricelist/priceList.vue
// module id = 95
// module chunks = 31